import{useContext}from"react";import{RadioGroupContext}from"../RadioGroup";export const useRadioGroup=()=>useContext(RadioGroupContext);